<template>
    <div>
        <!-- 页面固定头部 -->
        <a-anchor :getContainer="getModuleContainer" style="width: 100%">
            <!-- 面包屑组件 -->
            <FGBreadHead></FGBreadHead>
            <!-- //文本搜索内容 -->
            <div class="fun-panel fun-search-form-wrapper">
                <a-form :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                    <a-row :gutter="[0, 6]">
                        <a-col :span="6">
                            <a-form-item label="报名日期从">
                                <a-date-picker v-model="queryParams.bmrq1" width="100%" valueFormat="YYYY-MM-DD" style="width:100%" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="到">
                                <a-date-picker v-model="queryParams.bmrq2" valueFormat="YYYY-MM-DD" style="width:100%" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="会议名称">
                                <a-input-search ref="hymc" @search="isShow_hyxx = true" v-model="queryParams.hymc" />
                                <FGDataSelect
                                    :isShow.sync="isShow_hyxx"
                                    selectNo="JC101601"
                                    @saveselect="saveEvent_hyxx(arguments, queryParams)"
                                ></FGDataSelect>
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="会议类别">
                                <FGDictSelectCN dictNo="HY300102" v-model="queryParams.hylb" placeholder="" mode="multiple" />
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <a-row :gutter="[0, 6]">
                        <a-col :span="6"></a-col>
                        <a-col :span="18">
                            <span class="fun-search-form-buttons" :style="{ float: 'right', overflow: 'hidden' }">
                                <a-button type="primary" @click="loadData" style="margin-right: 8px">查询</a-button>
                                <a-button @click="reset">重置</a-button>
                            </span>
                        </a-col>
                    </a-row>
                </a-form>
            </div>
        </a-anchor>

        <div class="fun-panel">
            <a-spin :spinning="tableDataLoading">
                <!-- 工具栏 -->
                <vxe-toolbar
                    size="mini"
                    custom
                    :refresh="{
                        query: () => {
                            this.loadData();
                        }
                    }"
                >
                    <template v-slot:buttons>
                        <a-button type="primary" icon="plus" @click="insert">新增</a-button>
                        <a-button-group class="btnGroupCls">
                            <a-button :type="selDJZT === 0 ? btnPrimary : btnDefault" @click="handleSelDjztChange(0)">
                                全部
                            </a-button>
                            <a-button :type="selDJZT === 1 ? btnPrimary : btnDefault" @click="handleSelDjztChange(1)">
                                待提交
                            </a-button>
                            <a-button :type="selDJZT === 2 ? btnPrimary : btnDefault" @click="handleSelDjztChange(2)">
                                已提交
                            </a-button>
                        </a-button-group>
                    </template>
                </vxe-toolbar>
                <!-- 表格 -->
                <vxe-table
                    ref="table"
                    size="mini"
                    resizable
                    auto-resize
                    row-id="id"
                    align="left"
                    :max-height="$FG_util.getTableHeightDirect(2)"
                    header-align="center"
                    highlight-hover-row
                    highlight-current-row
                    show-overflow="tooltip"
                    :data="tableData"
                    :sort-config="{
                        trigger: 'cell',
                        defaultSort: { field: sort.field, order: sort.order },
                        remote: true,
                        orders: ['asc', 'desc']
                    }"
                    @sort-change="handleSortChange"
                    @cell-dblclick="cellDblclick"
                >
                    <vxe-table-column type="seq" title="序号" width="70" align="center"></vxe-table-column>
                    <vxe-table-column field="djzt" title="单据状态" width="120" align="center">
                        <template v-slot="scope">
                            <FGDictRendererCN ref="djzt" dictNo="HY300101" v-model="scope.row.djzt" />
                        </template>
                    </vxe-table-column>
                    <vxe-table-column field="hybmdbh" title="会议报名单编号" width="130" sortable align="center"> </vxe-table-column>
                    <vxe-table-column field="bmrq" title="报名日期" width="100" align="center"></vxe-table-column>
                    <vxe-table-column field="hymc" title="会议名称" min-width="120"> </vxe-table-column>
                    <vxe-table-column field="hylb" title="会议类别" width="120" align="center"> </vxe-table-column>
                    <!-- <vxe-table-column field="lrrxm" title="录入人" width="180" align="center"></vxe-table-column> -->
                    <vxe-table-column field="lrrq" title="录入时间" width="140" aalign="center"> </vxe-table-column>
                    <vxe-table-column title="操作" width="180" align="center">
                        <template v-slot="scope">
                            <span
                                class="btn_edit"
                                v-if="scope.row.djzt === '制定' || scope.row.djzt === '撤销' || scope.row.djzt === '否决'"
                                @click="remove(scope.row)"
                                >删除</span
                            >
                            <span
                                class="btn_edit"
                                v-if="scope.row.djzt === '制定' || scope.row.djzt === '撤销' || scope.row.djzt === '否决'"
                                @click="edit(scope.row)"
                                >编辑</span
                            >
                            <span class="btn_edit" @click="view(scope.row)">查看</span>
                        </template>
                    </vxe-table-column>
                </vxe-table>
                <vxe-pager
                    background
                    size="mini"
                    style="margin-top: 5px"
                    :current-page.sync="pageinfo.pageNo"
                    :page-size.sync="pageinfo.pageSize"
                    :total="pageinfo.total"
                    :layouts="['PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']"
                    @page-change="handlePageChange"
                >
                </vxe-pager>
            </a-spin>
        </div>
    </div>
</template>

<script>
export default {
    name: "BmlrBrowse",
    components: {},
    data() {
        return {
            tableData: [], //表格数据

            queryParams: {},
            // 分页
            pageinfo: {
                pageNo: 1,
                pageSize: 20,
                total: 0
            },
            // 排序
            sort: {
                field: "hybmdbh",
                order: "desc"
            },
            tableDataLoading: false,
            btnPrimary: "primary",
            btnDefault: "default",
            selDJZT: 1,
            isShow_hyxx: false
        };
    },
    computed: {
        // 是否显示编辑界面
        editIsVisible: {
            get() {
                return this.showEdit;
            },
            set(newVal) {
                this.$emit("update:showEdit", newVal);
            }
        },
        formIsVisible: {
            get() {
                return this.showForm;
            },
            set(newVal) {
                this.$emit("update:showForm", newVal);
            }
        },

        // 当前编辑记录id
        editDataId: {
            get() {
                return this.dataId;
            },
            set(newVal) {
                this.$emit("update:dataId", newVal);
            }
        }
    },
    activated() {
        this.loadData(this.editDataId);
    },
    methods: {
        saveEvent_hyxx(val, currentrow) {
            if (val && val.length > 0) {
                this.queryParams.hyid = val[0][0].ID;
                this.queryParams.hymc = val[0][0].HYMC;
                this.queryParams.hylb = [];
                this.queryParams.hylb.push(val[0][0].HYLB);
                this.queryParams.ksrq = val[0][0].KSRQ;
                this.queryParams.jsrq = val[0][0].JSRQ;
                this.queryParams.hyksrq = val[0][0].HYKSRQ;
                this.queryParams.hyjsrq = val[0][0].HYJSRQ;
                this.queryParams.zynr = val[0][0].ZYNR;
                this.queryParams.hydd = val[0][0].HYDD;
                this.queryParams.lxr = val[0][0].LXR;
                this.queryParams.lxdh = val[0][0].LXDH;
            }
        },
        //选择不同状态
        handleSelDjztChange(selType) {
            this.selDJZT = selType;
            this.loadData();
        },
        //点击页码
        handlePageChange({ currentPage, pageSize }) {
            this.pageinfo.pageNo = currentPage;
            this.pageinfo.pageSize = pageSize;
            this.loadData();
        },
        //点击表头排序
        handleSortChange({ property, order }) {
            this.sort.field = property;
            this.sort.order = order;
            this.loadData();
        },
        //查看
        view(row) {
            // 设置编辑记录id
            this.editDataId = row.id;
            // 显示编辑界面
            this.editIsVisible = false;
            this.formIsVisible = true;
        },
        //删除
        remove(row) {
            this.$FG_message.confirm("P0000", "删除").then((type) => {
                if (type === "ok") {
                    this.tableDataLoading = true;
                    this.$FG_http
                        .post("./api/main/hybm/delete", {
                            id: row.id
                        })
                        .then(({ success, data, errMsg }) => {
                            this.tableDataLoading = false;
                            if (success) {
                                this.loadData(row.id);
                            }
                        });
                }
            });
        },
        //查询列表数据
        loadData(id) {
            this.queryParams.selType = this.selDJZT;
            // 如果没有指定选中记录则选中刷新前选中的记录
            if (!id) {
                let row = this.$refs.table.getCurrentRecord();
                if (row) {
                    id = row.id;
                }
            }
            this.tableDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/hybm/list",
                    {
                        funid: "RY600102",
                        menuid: "097550F3-983F-4CBE-95DD-19EC2DA08F90",
                        defaulttablename: "HY_HYBMD",
                        pageNo: this.pageinfo.pageNo,
                        pageSize: this.pageinfo.pageSize,
                        queryParams: this.queryParams,
                        sort: this.sort
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.tableDataLoading = false;
                    if (success) {
                        this.tableData = data.data;
                        // 需要设置当前页，因为查询可能导致当前页发生变化
                        this.pageinfo.pageNo = data.pageinfo.pagenum;
                        this.pageinfo.total = data.pageinfo.maxrow;
                    } else {
                        // 数据加载失败清空表格
                        this.tableData = [];
                    }
                })
                .then(() => {
                    this.$nextTick(() => {
                        let row = null;
                        // 获取之前选择的记录
                        if (id) {
                            row = this.$refs.table.getRowById(id);
                        }
                        // 如果之前没有选择记录且表格不为空则选择第一条记录
                        if (!row && this.tableData.length > 0) {
                            row = this.$refs.table.getRowById(this.tableData[0].id);
                        }
                        if (row) {
                            // 设置当前记录
                            this.$refs.table.setCurrentRow(row);
                        } else {
                            // 清空当前行
                            this.$refs.table.clearCurrentRow();
                        }
                    });
                });
        },
        //重置文本内容
        reset() {
            this.queryParams = {};
        },
        //新增
        insert() {
            // 设置编辑记录id
            this.editDataId = null;
            // 显示编辑界面
            this.editIsVisible = true;
        },
        // 编辑
        edit(row) {
            // 设置编辑记录id
            this.editDataId = row.id;
            // 显示编辑界面
            this.editIsVisible = true;
        },
        cellDblclick({ row }) {
            if (row.djzt === "制定" || row.djzt === "撤销" || row.djzt === "否决") {
                this.edit(row);
            } else {
                this.view(row);
            }
        }
    }
};
</script>
